import React from 'react'
import facebookIconRoundImage from 'social_media/facebook-icon-round.png'
import googleIconRoundImage from 'social_media/google-icon-round.png'

const SocialAuthButtons = ({ onFacebookClick, onGoogleClick, disabled }) => (
  <div className="space-y-6">
    <div className="flex items-center gap-2">
      <div className="flex-1 h-px bg-base-border" />
      <span className="text-sm font-medium text-base-gray-text-secondary">or continue with</span>
      <div className="flex-1 h-px bg-base-border" />
    </div>
    <div className="flex justify-center items-center gap-3">
      <button
        type="button"
        className="w-10 h-10 flex justify-center items-center disabled:opacity-50 hover:opacity-90"
        onClick={onFacebookClick}
        disabled={disabled}
        aria-label="Continue with Facebook"
      >
        <img
          src={facebookIconRoundImage}
          alt=""
          className="w-10 h-10"
          aria-hidden="true"
        />
      </button>
      <button
        type="button"
        className="w-10 h-10 flex justify-center items-center disabled:opacity-50 hover:opacity-90"
        onClick={onGoogleClick}
        disabled={disabled}
        aria-label="Continue with Google"
      >
        <img
          src={googleIconRoundImage}
          alt=""
          className="w-10 h-10"
          aria-hidden="true"
        />
      </button>
    </div>
  </div>
)

export default SocialAuthButtons
